const storageKey = "conlit.participant-session-id";
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function participantSessionIdFromPath(pathname: string) {
  const sessionId = pathname.match(/^\/play\/([^/]+)(?:\/|$)/)?.[1];
  return sessionId && uuidPattern.test(sessionId) ? sessionId : undefined;
}

export function rememberParticipantSession(sessionId: string) {
  if (uuidPattern.test(sessionId)) {
    globalThis.localStorage?.setItem(storageKey, sessionId);
  }
}

export function getRememberedParticipantSession() {
  const sessionId = globalThis.localStorage?.getItem(storageKey);
  return sessionId && uuidPattern.test(sessionId) ? sessionId : undefined;
}

export function clearRememberedParticipantSession() {
  globalThis.localStorage?.removeItem(storageKey);
}
